// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.level-filter {
    display: flex;
    align-items: stretch;
    justify-content: space-between;
    width: 100%;
}
.level-filter button {
    background-color: transparent;
    border: 0;
}
.level-filter button:hover {
}
.level-filter select {
    flex-grow: 1;
    background-color: transparent;
    border: 0;
}
.layertree-option-levelfilter {
    background-color: #afb3b2;
    padding: 20px 0 20px 5px !important;
}
`, "",{"version":3,"sources":["webpack://./js/style/LevelFilter.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,oBAAoB;IACpB,8BAA8B;IAC9B,WAAW;AACf;AACA;IACI,6BAA6B;IAC7B,SAAS;AACb;AACA;AACA;AACA;IACI,YAAY;IACZ,6BAA6B;IAC7B,SAAS;AACb;AACA;IACI,yBAAyB;IACzB,mCAAmC;AACvC","sourcesContent":[".level-filter {\n    display: flex;\n    align-items: stretch;\n    justify-content: space-between;\n    width: 100%;\n}\n.level-filter button {\n    background-color: transparent;\n    border: 0;\n}\n.level-filter button:hover {\n}\n.level-filter select {\n    flex-grow: 1;\n    background-color: transparent;\n    border: 0;\n}\n.layertree-option-levelfilter {\n    background-color: #afb3b2;\n    padding: 20px 0 20px 5px !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
